import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';


export function getCiudadListSuccess(ciudad) {
  return {type: types.LOAD_CIUDAD_LIST_SUCCESS, ciudad};
}



export function getCiudadList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CiudadApi.getCiudadList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(ciudad => {                  
                  dispatch(getCiudadListSuccess(ciudad));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCiudadSuccess(catalogo) {
  return {type: types.LOAD_CIUDAD_SUCCESS, catalogo};
}

export function getCiudad(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CiudadApi.getCiudad(id, token).then(ciudad => {   
        dispatch(getCiudadSuccess(ciudad));
        return ciudad;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(ciudad) {
  return {type: types.SAVE_CIUDAD_SUCCESS, ciudad};
}


export function save(ciudad, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CiudadApi.save(ciudad, token).then(ciudadGuardado => {   
    dispatch(saveSuccess(ciudadGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getCiudadComboSuccess(datos) {
  return {type: types.GET_CIUDADS_COMBO_SUCCESS, datos};
}

export function getCiudadCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CiudadApi.getCiudadCombo(token).then(datos => {   
        
      dispatch(getCiudadComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(ciudad) {
  return {type: types.BORRAR_CIUDAD_SUCCESS, ciudad};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CiudadApi.borrar(id, token ).then(ciudad => {
               
                  dispatch(borrarSuccess(ciudad));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(ciudad) {
  return {type: types.ACTIVAR_CIUDAD_SUCCESS, ciudad};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CiudadApi.activar(id, token).then(ciudad => {
               
                  dispatch(activarSuccess(ciudad));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CIUDAD, filtro};
}



